import { COOKIE_NAME_SITE_ID, COOKIE_NAME_SITE_ID_OLD, COOKIE_NAME_EDGESCAPE_SITE_ID,
    COOKIE_NAME_COUNTRY, COOKIE_NAME_SITE_CHOICE, COOKIE_NAME_INVENTORY_POOL,
    PRIMARY_HEADER_PROMO, COUNTRIES_TO_OVERRIDE_DEFAULT_SITE_SWITCH_COUNTRY,
    COOKIE_NAME_SITE_SWITCH_DISPLAY_AS_MODAL
} from '../constants';

import Cookies from '../services/cookies';
import localCache from '../utils/cacheUtils';
import { launchSiteSwitchModal } from '@core/js/utils/asyncLaunchers';

import { generate } from '../../../core/js/utils/componentUtils';

import {
    chooseSiteId,
    isWebview,
    // getUniqueVisitsFromCookie,
    setCountryCookieToDefaultCountryCodeOfSiteId
} from '../../../core/js/utils/cookieUtils';

import template from 'core-country-interstitial.j2';
import { debug as logDebug } from '../../../core/js/utils/logger';
import { createGAEvent } from '../../../core/js/utils/analyticsUtils';
import { handleUtagEvent } from '../../../core/js/actions/initialActions';
import { siteSwitchingActive } from '../actions/interstitialActions';
import { getInventoryPoolForSiteId } from '../utils/siteConfigUtils';
import { updateHeaderSaga } from '../sagas/headerSagas';
import { getPromoBannersSaga } from '../sagas/promoSagas';

import { setupFixedHeader } from '../../../core/js/utils/headerUtils';

/*
/**
 * Check to see if on small screen and and the first page visit
 * in order to delay the interstitial from showing
 * Sets cookie if we delay the interstitial
 * @param {object} state current redux state
 * @returns {boolean} whether to delay the interstitial or not
 *//*
function shouldDelayInterstitial(state) {
    const isSmallish = _.get(state, 'core.deviceCharacteristics.is_smallish', false);
    const pageVisitCount = getUniqueVisitsFromCookie();

    if (isSmallish && pageVisitCount <= 1) {
        // Set cookie stating we deferred the interstitial
        Cookies.setCookie(COOKIE_INTERSTITIAL_DEFERRED, true);
        return true;
    }

    return false;
}*/

let bannerDisplayReported = false;
let eventLabel = '';

function parseChosenSite(rawSiteChoiceValue) {
    try {
        if (!rawSiteChoiceValue) {
            // eslint-disable-next-line no-undefined
            return undefined;
        }

        const parsedCookieValue = rawSiteChoiceValue.split('->');

        return {
            choiceSiteId: parsedCookieValue[0],
            chosenSiteId: parsedCookieValue[1]
        };
    } catch (err) {
        logDebug(`Could not parse site choice cookie value ${rawSiteChoiceValue}: ${err}`);
        // eslint-disable-next-line no-undefined
        return undefined;
    }
}

/**
 * Check cookie values to determine if we should show
 * the site switching interstitial modal
 * @param {object} state current redux state
 * @param {boolean} integrationTestSuppress whether integration test wants to suppress the interstitial
 * @returns {boolean} whether we should show interstitial or not
 */
export function shouldShowInterstitial(state, integrationTestSuppress = false) {

    // allow integration tests to suppress
    if (integrationTestSuppress) {
        return false;
    }

    // If core setting is false or current view is webview
    // don't show interstitial
    if (!_.get(state, 'core.showSiteSwitchingModal', false) || isWebview()) {
        return false;
    }

    const contextPathSiteId = Cookies.getCookieByName(COOKIE_NAME_SITE_ID);
    const edgescapeSiteId = Cookies.getCookieByName(COOKIE_NAME_EDGESCAPE_SITE_ID);
    const siteChoice = parseChosenSite(Cookies.getCookieByName(COOKIE_NAME_SITE_CHOICE));

    // If we hae no edgescape site ID, don't show interstitial
    if (!edgescapeSiteId) {
        return false;
    }

    // Do we have both site id values? If not, don't show interstitial
    if (contextPathSiteId !== edgescapeSiteId) {
        // Does my site choice match my current site? If so, don't
        // don't show interstitial
        if (siteChoice && siteChoice.choiceSiteId === contextPathSiteId) {
            return false;
        }

        // Should we delay interstitial?
        // Commenting call out for now as we may add it back in the future
        // if (shouldDelayInterstitial(state)) {
        //     return false;
        // }

        return true;
    }

    return false;
}

/**
 * Check cookie values to determine if we should show
 * the site switching interstitial as modal or banner
 * @param {object} state current redux state
 * @returns {boolean} whether we should show interstitial or not
 */
export function shouldDisplayInterstitialAsModal() {
    return Cookies.getCookieByName(COOKIE_NAME_SITE_SWITCH_DISPLAY_AS_MODAL) === "1";
}

/*
function addPageViewTracking(store) {
    const state = store.getState();
    const pageId = _.get(state, 'core.localizations.containers.analyticsContainer.core_interstitial_welcome_lightbox');
    const categoryId = _.get(state,
         'core.localizations.containers.analyticsContainer.core_interstitial_welcome_lightbox_help'
    );
    const uTagData = {
        page_id: `${pageId}`,
        category_id: `${categoryId}`
    };

    store.dispatch(handleUtagEvent(uTagData, 'view'));
}*/

function chooseContextPath() {
    const currentSiteId = $('.js-choose-context-path-site').attr('data-site-id') || Cookies.getCookieByName(COOKIE_NAME_SITE_ID);

    chooseSiteId(currentSiteId, currentSiteId);
    localCache.clear();
}

function setCountryCookieForSelectedSiteId(store, siteId) {
    const siteConfig = _.get(store.getState(), 'core.siteConfig', {});

    return setCountryCookieToDefaultCountryCodeOfSiteId(siteId, siteConfig);
}

export function chooseContextPathSite(store, siteId) {
    if (!_.isString(siteId)) {
        // eslint-disable-next-line no-param-reassign
        siteId = Cookies.getCookieByName(COOKIE_NAME_SITE_ID);
    }

    chooseContextPath();

    const state = store.getState();

    if (!_.get(state, 'core.constants.edgescapeCountryTakesPrecedence')) {
        const updatedCountry = setCountryCookieForSelectedSiteId(store, siteId);

        if (updatedCountry) {
            store.runSaga(updateHeaderSaga, updatedCountry).done.then(() => {
                const updatedState = store.getState();
                const countryCode = Cookies.getCookieByName(COOKIE_NAME_COUNTRY);

                const inventoryPool = getInventoryPoolForSiteId(
                    _.get(updatedState, 'core.siteConfig'),
                    countryCode,
                    siteId
                );

                if (_.isString(inventoryPool) && !_.isEmpty(inventoryPool)) {
                    Cookies.setCookie(COOKIE_NAME_INVENTORY_POOL, inventoryPool);
                }
            });
        }
    }
}

export function changeContextPathSiteAndDismiss(store, e) {
    const siteId = Cookies.getCookieByName(COOKIE_NAME_SITE_ID);

    chooseContextPathSite(store, e, siteId);
    store.dispatch(siteSwitchingActive(false));
}

/**
 * Attach component events to DOM
 * @param {object} store Current Redux Store
 * @returns {undefined}
 */
function attachEvents(store) {
    const state = store.getState();
    const pageType = _.get(state, 'core.pageType');
    const { isModal } = getCountryCodeInterstitialData(state).countryCodeInterstitial;

    // Stay on path site button
    $(document).on(this.scopedEvent('touchend click'), '.js-choose-context-path-site', (e) => {
        e.preventDefault();

        const gaEvent = createGAEvent(
            pageType,
            'ssb click stay',
            eventLabel,
            { 'dy_noninteraction': false }
        );

        store.dispatch(handleUtagEvent(gaEvent, 'link'));

        changeContextPathSiteAndDismiss(store, e);

        if (isModal) {
            closeModal();
        }
    });

    // Switch to local site button
    $(document).on(this.scopedEvent('touchend click'), '.js-choose-local-site', (e) => {
        e.preventDefault();

        const localSiteId = Cookies.getCookieByName(COOKIE_NAME_EDGESCAPE_SITE_ID);
        const localCountry = Cookies.getCookieByName(COOKIE_NAME_COUNTRY);
        const overrideCountriesList = COUNTRIES_TO_OVERRIDE_DEFAULT_SITE_SWITCH_COUNTRY;
        let updatedCountry = false;

        // eslint-disable-next-line func-names
        const localCountryOverridesDefaultCountry = _.find(overrideCountriesList, function(o) {
            return o === localCountry;
        });

        const gaEvent = createGAEvent(
            pageType,
            'ssb click switch',
            eventLabel,
            { 'dy_noninteraction': false }
        );

        store.dispatch(handleUtagEvent(gaEvent, 'link'));

        localCache.clear();
        const localSiteURL = $(this.scopedSelector('.js-choose-local-site')).attr('data-url');

        // In certain situations, we want to override the default country for the given siteId
        // currently just for NL but ya never know
        if (!localCountryOverridesDefaultCountry) {
            Cookies.setCookie(COOKIE_NAME_SITE_ID, localSiteId);
            Cookies.setCookie(COOKIE_NAME_SITE_ID_OLD, localSiteId);
            updatedCountry = setCountryCookieForSelectedSiteId(store, localSiteId);
        }

        if (updatedCountry) {
            store.runSaga(updateHeaderSaga, updatedCountry).done.then(() => {
                window.location = localSiteURL;
            });
        } else {
            window.location = localSiteURL;
        }

        if (isModal) {
            closeModal();
        }
    });
}

function getCountryCodeInterstitialData(state) {
    const contextPathSiteId = Cookies.getCookieByName(COOKIE_NAME_SITE_ID);
    const edgescapeSiteId = Cookies.getCookieByName(COOKIE_NAME_EDGESCAPE_SITE_ID);
    const countryCode = Cookies.getCookieByName(COOKIE_NAME_COUNTRY);
    const isModal = shouldDisplayInterstitialAsModal();
    const localContextPath = _.get(
        state,
        `core.constants.siteIdToContextPathMappings.${edgescapeSiteId}.default`,
        _.get(state, 'core.siteId'),
    );
    const countryCodeContent = _.get(
        state,
        `core.constants.siteModalCountryMapping.${countryCode}`,
        _.get(state, `core.constants.siteModalCountryMapping.US`)
    );

    // Hardcoding in netherlands button text override
    const localSiteTranslationKey = countryCode === 'NL'
        ? 'choose-local-site-nl'
        : 'choose-local-site-' + edgescapeSiteId;

    const localURL = localContextPath;
    const dictionary = {
        countryCodeInterstitial: {
            contextPathSiteId,
            edgescapeSiteId,
            localSiteTranslationKey,
            localURL,
            countryCode,
            countryCodeContent,
            isModal,
        }
    };

    return dictionary;
}

function onStateChange(store, watchValue, oldVal, newVal) {
    if (newVal === true) {
        const state = store.getState();

        const dictionary = getCountryCodeInterstitialData(state);
        const {
            contextPathSiteId,
            edgescapeSiteId,
        } = dictionary.countryCodeInterstitial;

        this.render(store, this, dictionary);

        const pageType = _.get(state, 'core.pageType');
        if (!bannerDisplayReported) {
            eventLabel = `${contextPathSiteId}|${edgescapeSiteId}`;
            bannerDisplayReported = true;

            const gaEvent = createGAEvent(
                pageType,
                'ssb displayed',
                `${contextPathSiteId}|${edgescapeSiteId}`,
                { 'dy_noninteraction': true }
            );

            store.dispatch(handleUtagEvent(gaEvent, 'link'));
        }

        // get updated primary header promo when site switching banner shows
        store.runSaga(getPromoBannersSaga, [PRIMARY_HEADER_PROMO]);

        // addPageViewTracking(store);
    } else {
        this.render(store, this, {});
    }
}

/**
 * re-rendering the fixed header since this content displays above the it
 *
 */
function afterRender(store) {
    const state = store.getState();
    const dictionary = getCountryCodeInterstitialData(state);
    const { isModal } = dictionary.countryCodeInterstitial;

    if (isModal && _.get(state, 'core.siteSwitchingActive', false)) {
        launchSiteSwitchModal({}, 'modal.siteSwitch', dictionary);
    } else {
        setupFixedHeader();
    }
}

export function closeModal() {
    $.event.trigger({
        type: 'MODAL_CLOSE'
    });
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-country-interstitial',
        template: template,
        name: 'countryInterstitialComponent',
        replace: 'once',
        attachEvents: attachEvents,
        afterCloseAction: chooseContextPathSite,
        afterRender: afterRender,
        onStateChange: onStateChange,
        watch: 'core.siteSwitchingActive'
    };

    return generate(config, store, overrides);
}
